<template>
  <div class="compose-message">
    <form @submit.prevent="submit" :class="errorClass" class="inner-form">
      <div class="send-to">
        <span>TO:</span>
        <div class="recipient-section">
          <span v-if="recipients.length == 0">Add at least one recipient</span>
          <span v-for="(recipient, recipientIndex) in recipients" :key="recipientIndex" class="message-recipient">
            {{recipient.name ? recipient.name : recipient}}
            <span @click="removeFunction(recipientIndex)" class="remove-icon">
              <rp-sprite name="close"></rp-sprite>
            </span>
          </span>
        </div>
        <span class="add-recipient" @click="onClick">Add recipients</span>
      </div>
      <div class="message-section">
        <rp-textinput
          v-model="resource.title"
          placeholder="Give your message a title"
          :error="titleError"
          @input="touch('title')"/>

        <rp-text-box
          v-model="resource.message"
          placeholder="Type your message here..."
          :error="messageError"
          :rows=12
          @input="touch('message')"
        >
        </rp-text-box>
        <div class="button-group">
          <rp-checkbox
            label='Important'
            id="important"
            v-model="resource.value" />
          <rp-button :disabled="recipients.length == 0 || isInvalid" type="primary">Send message</rp-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import TextBox from '../../../components/ui/inputs/TextBox'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import Checkbox from '../../../components/ui/inputs/Checkbox'
  import Sprite from '../../../components/ui/Sprite'

  export default {
    name: 'ComposeMessageForm',
    mixins: [validationMixin, form],

    props: {
      onClick: Function,
      isEmpty: String,
      recipients: Array,
      removeFunction: Function
    },
    
    data() {
      return {
        checked: true
      }
    },

    components: {
      'rp-button': Button,
      'rp-text-box': TextBox,
      'rp-textinput': TextInput,
      'rp-checkbox': Checkbox,
      'rp-sprite': Sprite
    },

    computed: {...errorMessages(['recipient', 'title', 'message'])},

    validations: {
      resource: {
        title: {required},
        message: {required},
        value: {required: false}
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '../../../styles/base/variables'

  .inner-form
    background: transparent
    box-shadow: none

  .send-to
    display: flex
    align-items: center
    justify-content: space-between
    margin-bottom: 15px
    span
      color: $color-text-invert
    .text-input
      width: 65%
    .recipient-section
      display: flex
      align-items: center
      flex-wrap: wrap
      margin-left: 10px
      .message-recipient
        color: $color-text
        margin-bottom: 5px
        margin-right: 10px
        padding: 5px 10px
        background: $color-grey-light
        border-radius: 25px
        .remove-icon
          cursor: pointer
          margin-left: 5px
          .sprite
            width: 10px
            height: 10px
    .add-recipient
      display: flex
      justify-content: center
      align-items: center
      margin-left: auto
      border: 0
      opacity: 1
      transition: opacity $transition-duration ease-in-out
      cursor: pointer
      padding: 0px $pad
      height: 30px
      border-radius: 3px
      border: 2px solid
      background: none
      font-family: $app-font-slab
      font-weight: $font-light
      font-size: 11px
      line-height: 1
      transition: background-color $transition-duration $transition-easing, border $transition-duration $transition-easing
      user-select: none
      outline: none
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0)
      -webkit-tap-highlight-color: transparent

      color: $color-text-invert
      border-color: $color-grey
      text-transform: uppercase
  
  .message-section
    padding: 10px 20px 20px
    background: $color-panel-bg
    box-shadow: 1px 1px 5px $color-shadow

  .text-box
    margin-top: 15px
  .button-group
    display: flex
    align-items: center
    justify-content: space-between
    button
      margin-top: 0
</style>

<style scoped>
  .text-box >>> textarea {
    padding-left: 0;
    padding-right: 0;
    border: 0;
  }
  .text-box >>> .input-label {
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/ComposeMessage.vue